<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter
            :headers="headers"
            :viewName="viewName"
            v-on:applyFilter="applyFilter"
            v-on:quickFilter="quickFilter"
          ></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :id="'r-' + item.ID">
                <td>{{ item.ID }}</td>
                <td>{{ item.Name }}</td>
                <td>{{ item.IsHidden ? 'Không sử dụng' : '' }}</td>
                <td>{{ item.IsDefault ? 'Mặc định' : '' }}</td>
                <td>{{ (item.ModifiedDate || item.CreatedDate) | display_date }}</td>
                <td>{{ item.ModifiedBy }}</td>
                <td class="text-center">
                  <v-icon medium class="mr-2" @click="editItem(item)"
                    >fa-edit</v-icon
                  >
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogNewItem" persistent max-width="500px">
      <v-form ref="validate_form" lazy-validation>
        <v-card>
          <v-card-title>
              <span class="title">Loại hàng</span>
          </v-card-title>
          <v-card-text>
              <v-layout row wrap pa-3>
                  <v-flex lg12 md12 sm12>
                    <v-text-field label="Tên loại hàng" v-model="currentItem.Name" :rules="require_validation"></v-text-field>
                  </v-flex>
                  <v-flex lg12 md12 sm12>
                      <v-switch v-model="currentItem.IsHidden" label="Không sử dụng"></v-switch>
                  </v-flex>
                  <v-flex lg12 md12 sm12>
                      <v-switch v-model="currentItem.IsDefault" label="Mặc định"></v-switch>
                  </v-flex>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" @click="dialogNewItem = false">Đóng</v-btn>
              <v-btn @click="onCreateNewItem">Đồng ý</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering,
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"],
        },
        {
          text: "Tên loại hàng",
          value: "Name",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Ẩn",
          value: "IsHidden",
          filterable: true,
          values: [{value: 0, name: 'Sử dụng'}, {value: 1, name: 'Không sử dụng'}],
          dataType: dataType["Enum"],
        },
        {
          text: "Mặc định",
          value: "IsDefault",
          filterable: true,
          values: [{value: 0, name: ''}, {value: 1, name: 'Mặc định'}],
          dataType: dataType["Enum"],
        },
        {
          text: "Ngày sửa",
          value: "ModifiedDate",
          filterable: true,
          dataType: dataType["Date"],
        },
        {
          text: "Người sửa",
          value: "ModifiedBy",
          filterable: true,
          dataType: dataType["String"],
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false,
        },
      ],
      pagination: { ...configs.PAGINATION, sortBy: ["ID"]},
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "productType_list",
      filterConditions: [],
      quickFilterConditions: [],
      require_validation: [(v) => !!v || "Trường dữ liệu không được để trống."],
      dialogNewItem: false
    };
  },
  watch: {
    pagination: {
      handler: function (val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions)
          ? filterConditions[this.viewName]
          : [];
        this.filter_data();
      },
      deep: true,
    }
  },
  computed: mapState({
    items: (state) => state.productType.all.data,
    total_rows: (state) => state.productType.all.total,
    currentItem: (state) => state.productType.selected,
    loading: (state) => state.productType.loading
  }),
  methods: {
    filter_data: function () {
      var param = {
        pagination: this.pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions,
      };
      this.$store.dispatch("productType/getList", param);
    },
    editItem: function (item) {
      this.$store.commit("productType/setDetail", {data: {...item}});
      this.dialogNewItem = true;
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy;
      let sortDesc = this.pagination.sortDesc;
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      this.$store.commit("productType/setDetail", {data: {ID: 0, Name: '', IsHidden: 0}});
      this.dialogNewItem = true;
    },
    onCreateNewItem() {
      this.$store.dispatch("productType/setDetail", {data: {...this.currentItem}, id: this.currentItem.ID});
      this.dialogNewItem = false;
    }
  },
  mounted() {
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  },
};
</script>
